module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 560794059287,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.08446703483622493,
		"cl_weight": 0.25151056488915086,
		"fossil_bank_score": 13.8871,
		"fossil_insure_score": 25.5845,
		"wff_mil_weight": 0.035215911119327724,
		"mmc_weight": 0.035215911119327724,
		"cm_weight": 0.014784924152094692,
		"nw_weight": 0.02383571484314249,
		"wff_civ_weight": 0.010278117642090592,
		"gm_weight": 0.0013940215766801317,
		"gr_weight": 0.008884096065410461,
		"t_all_weight": 0.01823526137753547,
		"to_weight": 0.007721988022334217,
		"tm_weight": 0.010513273355201254,
		"po_producer_weight": 0.0017612848640195058,
		"po_financier_weight": 0.02567527924790793,
		"po_consumer_weight": 0.11661815834550497,
		"pp_weight": 0.19064518386826157,
		"borders_weight": 0.17230825110331074,
		"pp_high_weight": 0.003216288263656276,
		"borders_high_weight": 0.018829790162915357,
		"pff_all_weight": 0.2239367247551033,
		"pff_all_high_weight": 0.018829790162915357,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.829503475599836,
		"gef_score_a": 26.649917852599994,
		"gef_score_b": 9.15877174135838,
		"gef_score_c": 18.37122106555726,
		"gef_score_d": 0.6495928160771018,
		"gef_score_a_norm": 66.62479463149998,
		"gef_score_b_norm": 30.529239137861268,
		"gef_score_c_norm": 91.85610532778631,
		"gef_score_d_norm": 6.495928160771018,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": -0.68121,
		"trailing_return_m3": -7.50525,
		"trailing_return_m6": -1.75673,
		"trailing_return_y1": 12.05875,
		"trailing_return_y3": 12.14598,
		"trailing_return_y5": 15.57403,
		"trailing_return_y10": 12.28167,
		"trailing_return_y15": 12.93158,
		"trailing_return_y20": 10.25249,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 14458949892,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.08172611010455992,
		"cl_weight": 0.2223474990134033,
		"fossil_bank_score": 12.2025,
		"fossil_insure_score": 22.8791,
		"wff_mil_weight": 0.03705774495645626,
		"mmc_weight": 0.03705774495645626,
		"cm_weight": 0.014508688255760281,
		"nw_weight": 0.023432409569612556,
		"wff_civ_weight": 0.009429507422818171,
		"gm_weight": 0.0013130882200489053,
		"gr_weight": 0.008116419202769265,
		"t_all_weight": 0.016231290146824107,
		"to_weight": 0.006889857739224312,
		"tm_weight": 0.009341432407599793,
		"po_producer_weight": 0.001548366278387725,
		"po_financier_weight": 0.022632346602951773,
		"po_consumer_weight": 0.10411560315175453,
		"pp_weight": 0.16997595650465203,
		"borders_weight": 0.15495182939539898,
		"pp_high_weight": 0.0031335014243919807,
		"borders_high_weight": 0.017819579835461258,
		"pff_all_weight": 0.200853928225848,
		"pff_all_high_weight": 0.01783128940443267,
		"pff_all_extreme_weight": 0.00012023995201957283,
		"gef_score_norm": 53.45470157907479,
		"gef_score_a": 26.143521354923834,
		"gef_score_b": 8.64917579676702,
		"gef_score_c": 18.07372682257608,
		"gef_score_d": 0.588277604801322,
		"gef_score_a_norm": 65.35880338730958,
		"gef_score_b_norm": 28.8305859892234,
		"gef_score_c_norm": 90.36863411288041,
		"gef_score_d_norm": 5.88277604801322,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": -0.68706,
		"trailing_return_m3": -8.29304,
		"trailing_return_m6": -2.24206,
		"trailing_return_y1": 11.18919,
		"trailing_return_y3": 11.23117,
		"trailing_return_y5": 14.93153,
		"trailing_return_y10": 11.49641,
		"trailing_return_y15": 12.36713,
		"trailing_return_y20": 9.99388,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 57715564860,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.07074486223215129,
		"cl_weight": 0.003075174451674014,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.028178011187593777,
		"mmc_weight": 0.028178011187593777,
		"cm_weight": 0.0027275435048014834,
		"nw_weight": 0.007632079010528431,
		"wff_civ_weight": 0.001856837651402737,
		"gm_weight": 0.00075892901716297,
		"gr_weight": 0.0010979086342397671,
		"t_all_weight": 0.0021589779146700323,
		"to_weight": 0.0010478848157611334,
		"tm_weight": 0.0011110930989088991,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0023676263162127104,
		"pp_weight": 0.005243098268143285,
		"borders_weight": 0.008376212516185042,
		"pp_high_weight": 0.0034431284345899454,
		"borders_high_weight": 0.00468974490618158,
		"pff_all_weight": 0.010456186830152163,
		"pff_all_high_weight": 0.0049697493865953615,
		"pff_all_extreme_weight": 0.0027466825259523054,
		"gef_score_norm": 38.143716188088085,
		"gef_score_a": 19.796746762514154,
		"gef_score_b": 3.3716524226117355,
		"gef_score_c": 14.948205872477004,
		"gef_score_d": 0.027111130486707036,
		"gef_score_a_norm": 49.49186690628539,
		"gef_score_b_norm": 11.238841408705785,
		"gef_score_c_norm": 74.74102936238502,
		"gef_score_d_norm": 0.27111130486707036,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": -2.29981,
		"trailing_return_m3": -13.80644,
		"trailing_return_m6": -9.99599,
		"trailing_return_y1": 0.75935,
		"trailing_return_y3": 3.16834,
		"trailing_return_y5": 9.75472,
		"trailing_return_y10": 6.26846,
		"trailing_return_y15": 8.38299,
		"trailing_return_y20": 7.71762,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 38188797218,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.0823147184622314,
		"cl_weight": 0.2325104143174556,
		"fossil_bank_score": 12.7596,
		"fossil_insure_score": 23.9388,
		"wff_mil_weight": 0.03745306582561561,
		"mmc_weight": 0.03745306582561561,
		"cm_weight": 0.015055855903818726,
		"nw_weight": 0.024139619453304482,
		"wff_civ_weight": 0.009776664665598511,
		"gm_weight": 0.001342142858500856,
		"gr_weight": 0.008434521807097655,
		"t_all_weight": 0.01688680742361839,
		"to_weight": 0.007151091006607451,
		"tm_weight": 0.009735716417010942,
		"po_producer_weight": 0.0016230734482288855,
		"po_financier_weight": 0.02366892027151734,
		"po_consumer_weight": 0.10883166111851919,
		"pp_weight": 0.17760509119287426,
		"borders_weight": 0.1617136366203665,
		"pp_high_weight": 0.0031349758935291976,
		"borders_high_weight": 0.018448269471663042,
		"pff_all_weight": 0.20964798925349082,
		"pff_all_high_weight": 0.018448269471663042,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.9189909356393,
		"gef_score_a": 26.33549813825334,
		"gef_score_b": 8.809622085795601,
		"gef_score_c": 18.16848937845152,
		"gef_score_d": 0.6053813331320813,
		"gef_score_a_norm": 65.83874534563334,
		"gef_score_b_norm": 29.365406952652002,
		"gef_score_c_norm": 90.84244689225758,
		"gef_score_d_norm": 6.053813331320813,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": -0.60681,
		"trailing_return_m3": -8.01942,
		"trailing_return_m6": -1.83657,
		"trailing_return_y1": 11.77573,
		"trailing_return_y3": 11.71992,
		"trailing_return_y5": 15.26481,
		"trailing_return_y10": 11.88591,
		"trailing_return_y15": 12.69097,
		"trailing_return_y20": 10.17971,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 60400751329,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.10570924037111484,
		"cl_weight": 0.12872682410555034,
		"fossil_bank_score": 29.2222,
		"fossil_insure_score": 24.6128,
		"wff_mil_weight": 0.045117657163134504,
		"mmc_weight": 0.045117657163134504,
		"cm_weight": 0.022733027520570142,
		"nw_weight": 0.024687530069168514,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.017655700036997988,
		"to_weight": 0.008640363385173402,
		"tm_weight": 0.009015336651824586,
		"po_producer_weight": 0.013694487955849013,
		"po_financier_weight": 0.08073826497463835,
		"po_consumer_weight": 0.10871702172321569,
		"pp_weight": 0.014826569555909545,
		"borders_weight": 0.030547690576718134,
		"pp_high_weight": 0.0008508161497240041,
		"borders_high_weight": 0.006080524017384527,
		"pff_all_weight": 0.03300338098035475,
		"pff_all_high_weight": 0.006931340167108531,
		"pff_all_extreme_weight": 0.000305886428120051,
		"gef_score_norm": 57.55262079430008,
		"gef_score_a": 25.389449224881425,
		"gef_score_b": 13.365984930331939,
		"gef_score_c": 17.435244827862935,
		"gef_score_d": 1.3619418112178763,
		"gef_score_a_norm": 63.473623062203565,
		"gef_score_b_norm": 44.55328310110646,
		"gef_score_c_norm": 87.17622413931467,
		"gef_score_d_norm": 13.619418112178764,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 4.0199,
		"trailing_return_m3": 7.02052,
		"trailing_return_m6": 8.8124,
		"trailing_return_y1": 13.44259,
		"trailing_return_y3": 10.45701,
		"trailing_return_y5": 11.44906,
		"trailing_return_y10": 5.43867,
		"trailing_return_y15": 6.05359,
		"trailing_return_y20": 5.47193,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 16546934095,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.09783875790159771,
		"cl_weight": 0.12274547122230488,
		"fossil_bank_score": 7.9322,
		"fossil_insure_score": 6.889,
		"wff_mil_weight": 0.03386780414207092,
		"mmc_weight": 0.03386780414207092,
		"cm_weight": 0.006103650900845901,
		"nw_weight": 0.02024747126639391,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.003399381789679588,
		"to_weight": 0.003399381789679588,
		"tm_weight": 0,
		"po_producer_weight": 0.010622436379854393,
		"po_financier_weight": 0.02076570864459068,
		"po_consumer_weight": 0.010706090366124297,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 46.70783924213825,
		"gef_score_a": 22.54286903620682,
		"gef_score_b": 7.504884141506847,
		"gef_score_c": 16.402380594814044,
		"gef_score_d": 0.2577054696198064,
		"gef_score_a_norm": 56.357172590517045,
		"gef_score_b_norm": 25.01628047168949,
		"gef_score_c_norm": 82.01190297407021,
		"gef_score_d_norm": 2.577054696198064,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": 0.50499,
		"trailing_return_m3": 2.48755,
		"trailing_return_m6": 0.7886,
		"trailing_return_y1": 9.42953,
		"trailing_return_y3": 3.57654,
		"trailing_return_y5": 5.72103,
		"trailing_return_y10": 2.42147,
		"trailing_return_y15": 2.38223,
		"trailing_return_y20": 5.56456,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 6011238890,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.11398790659514244,
		"cl_weight": 0.12565843755945835,
		"fossil_bank_score": 28.9259,
		"fossil_insure_score": 17.883,
		"wff_mil_weight": 0.04023133261181396,
		"mmc_weight": 0.04023133261181396,
		"cm_weight": 0.01624628086657095,
		"nw_weight": 0.023214229477605316,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.012370290586771682,
		"to_weight": 0.006479792185054665,
		"tm_weight": 0.005890498401717016,
		"po_producer_weight": 0.011861380831326231,
		"po_financier_weight": 0.05798988016403411,
		"po_consumer_weight": 0.07465134170000111,
		"pp_weight": 0.011233883758580247,
		"borders_weight": 0.020727946400093053,
		"pp_high_weight": 0.0005436516801967335,
		"borders_high_weight": 0.004912086707399281,
		"pff_all_weight": 0.023968971901931597,
		"pff_all_high_weight": 0.005455738387596015,
		"pff_all_extreme_weight": 0.00019662898891331884,
		"gef_score_norm": 56.60132056516336,
		"gef_score_a": 25.352915467829074,
		"gef_score_b": 12.59202272789335,
		"gef_score_c": 17.395416149040127,
		"gef_score_d": 1.2609662203955507,
		"gef_score_a_norm": 63.38228866957268,
		"gef_score_b_norm": 41.97340909297783,
		"gef_score_c_norm": 86.97708074520062,
		"gef_score_d_norm": 12.609662203955507,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 3.05134,
		"trailing_return_m3": 5.41887,
		"trailing_return_m6": 6.24464,
		"trailing_return_y1": 12.71181,
		"trailing_return_y3": 8.31901,
		"trailing_return_y5": 10.04835,
		"trailing_return_y10": 4.72458,
		"trailing_return_y15": 5.02506,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 20267223634,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.09096522446455428,
		"cl_weight": 0.2004504081611856,
		"fossil_bank_score": 19.2576,
		"fossil_insure_score": 18.8614,
		"wff_mil_weight": 0.037715968591654346,
		"mmc_weight": 0.037715968591654346,
		"cm_weight": 0.015801538915469135,
		"nw_weight": 0.023707038001112683,
		"wff_civ_weight": 0.006578847625887131,
		"gm_weight": 0.0008757320140193968,
		"gr_weight": 0.005703115611867734,
		"t_all_weight": 0.015725951197355682,
		"to_weight": 0.007234417660742594,
		"tm_weight": 0.00849153353661309,
		"po_producer_weight": 0.005303280129667624,
		"po_financier_weight": 0.03723778706034872,
		"po_consumer_weight": 0.0989580552778055,
		"pp_weight": 0.117022891469381,
		"borders_weight": 0.11311110946156293,
		"pp_high_weight": 0.0022244593150015767,
		"borders_high_weight": 0.0138302644163954,
		"pff_all_weight": 0.14274269967626113,
		"pff_all_high_weight": 0.014030680635351938,
		"pff_all_extreme_weight": 0.0000739005282562978,
		"gef_score_norm": 55.10116079386776,
		"gef_score_a": 26.13962924808075,
		"gef_score_b": 10.092622324462681,
		"gef_score_c": 18.060031004035846,
		"gef_score_d": 0.8088782172820432,
		"gef_score_a_norm": 65.34907312020188,
		"gef_score_b_norm": 33.64207441487561,
		"gef_score_c_norm": 90.30015502017923,
		"gef_score_d_norm": 8.088782172820434,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 0.75588,
		"trailing_return_m3": -3.41902,
		"trailing_return_m6": 1.012,
		"trailing_return_y1": 12.19285,
		"trailing_return_y3": 10.45977,
		"trailing_return_y5": 13.13072,
		"trailing_return_y10": 8.76178,
		"trailing_return_y15": 9.03662,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 925
// module chunks = 0